<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "EventSignup",
  data: () => ({
    textAreaPlaceholder: "Hier haben Sie die Möglichkeit, uns besondere Bedürfnisse (z. B. Allergien o. ä.) vorab mitzuteilen.",
    message: ''
  }),
  props: {
    eventId: Number,
    signedUp: Boolean,
  },
  computed: {
    ...mapGetters("user", ["userEmail"])
  },
  methods: {
    ...mapActions("veranstaltungen", ["signUpForEvent"])
  }
}
</script>

<template>
<div class="pa-5 mb-2 mt-10" style="background: white">
  <template v-if="!signedUp">
  <div class="sign-up-title">Anmeldung</div>
    <div>
      <label>Ihre Nachricht</label>
      <v-textarea rows="5" auto-grow :placeholder="textAreaPlaceholder" v-model="message"
                  dense outlined filled hide-details single-line/>
    </div>
    <div class="d-flex align-end">
  <div class="flex-grow-1">
    <label>E-Mail-Adresse</label>
    <v-text-field class="pr-5" :value="userEmail" dense readonly outlined filled hide-details single-line></v-text-field>
  </div>
    <v-btn height="40" color="primary" @click="signUpForEvent({ eventId, message })">Jetzt anmelden</v-btn>
  </div>
  </template>
  <template v-else>
    <div class="d-flex flex-column align-center">
      <v-icon size="66">$mail2</v-icon>
      <p class="sign-up-title-success mb-1">Vielen Dank für Ihr Interesse!</p>
      <p class="sign-up-title-success-subtitle">Bitte überprüfen Sie Ihr E-Mail-Postfach auf eine Benachrichtigung. </p>
    </div>
  </template>
</div>
</template>

<style scoped>
.sign-up-title {
  font-size: 20px;
  font-weight: bold;
}

.sign-up-title-success{
  font-size: 30px;
  font-weight: bold;
}

.sign-up-title-success-subtitle {
  font-size: 16px;
  font-weight: bold;
}

label {
  font-size: 12px;
  font-weight: bold;
}
</style>